import { moveToFulfilled, moveToPending, moveToRejected } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { AudienceActivityLoadFulfilledAction } from '../../domains/audienceActivity/actions.types';
import { UserAudienceCountsAction } from '../../domains/leadersManagement/loadUserAudienceCountsActions.types';

import { UserAudienceCounts } from './types';

const initialState: UserAudienceCounts = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type UserAudienceCountsLoadAction = UserAudienceCountsAction | AudienceActivityLoadFulfilledAction;

const reducer: Reducer<UserAudienceCounts, UserAudienceCountsLoadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'USER_AUDIENCE_COUNTS.LOAD_PENDING':
      return moveToPending(state, [action.payload.userId]);
    case 'USER_AUDIENCE_COUNTS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities);
    case 'LEADERSHIP_ACTIVITY_FOR_NETWORK.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.leaderAudience);
    case 'USER_AUDIENCE_COUNTS.LOAD_REJECTED':
      return moveToRejected(state, [action.payload.userId], action.payload.error);
    default:
      return state;
  }
};

export default reducer;
